import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CustomerState {
  customerId: string | null;
}

const initialState: CustomerState = {
  customerId: null,
};

const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    setCustomerId(state, action: PayloadAction<string>) {
      state.customerId = action.payload;
    },
  },
});

export const { setCustomerId } = customerSlice.actions;
export const selectedCustomerId = (state: any) => state.customer.customerId;
export default customerSlice.reducer;

